// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-backdrop{background-color:rgba(0,0,0,.6)!important}", ""]);
// Exports
module.exports = exports;
